/* Modulo: Concern Tabs (cnt)
   Concern rail + panel swap + a quick-add that UPGRADES a form which already
   works without JS.

   `window.moduloLazyInit` is deliberately NOT used — it does not exist. Roadmap
   rule 5 mandates it and `extensions/modulo-theme/assets/modulo-core.js` is not
   on disk; 73 sections carry the dead call. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* A live query, not a load-time boolean, or a mid-session toggle is ignored. */
  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function scrollBy(el, delta) {
    if (reduced()) { el.scrollLeft += delta; return; }
    if (el.scrollBy) el.scrollBy({ left: delta, behavior: 'smooth' });
    else el.scrollLeft += delta;
  }

  /* A non-2xx must become a real Error carrying its status, or a 422 takes the
     success path on an add that never happened. */
  function thenJson(res) {
    return res.json()
      .catch(function () { return {}; })
      .then(function (data) {
        if (res.ok) return data;
        var err = new Error((data && (data.description || data.message)) || 'Could not add');
        err.status = res.status;
        throw err;
      });
  }

  function initSection(sectionEl) {
    if (sectionEl.moduloCnt) return;
    sectionEl.moduloCnt = true;

    var tabs = [].slice.call(sectionEl.querySelectorAll('[data-cnt-tab]'));
    var panels = [].slice.call(sectionEl.querySelectorAll('[data-cnt-panel]'));
    var rail = sectionEl.querySelector('[data-cnt-rail]');
    var railNavs = [].slice.call(sectionEl.querySelectorAll('[data-cnt-railnav]'));

    /* ─── the concern rail ─────────────────────────────────────────────── */
    function syncRail() {
      if (!rail) return;
      var max = rail.scrollWidth - rail.clientWidth - 1;
      /* Self-hide when nothing overflows. `hidden` alone does nothing here —
         an author `display: inline-flex` beats the UA's `[hidden]` rule — so
         the stylesheet restates it (the sr lesson). */
      var fits = max <= 0;
      for (var i = 0; i < railNavs.length; i++) {
        railNavs[i].hidden = fits;
        railNavs[i].disabled = railNavs[i].getAttribute('data-cnt-railnav') === 'prev'
          ? rail.scrollLeft <= 1
          : rail.scrollLeft >= max;
      }
    }

    for (var r = 0; r < railNavs.length; r++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-cnt-railnav') === 'prev' ? -1 : 1;
          scrollBy(rail, dir * rail.clientWidth * 0.8);
        });
      })(railNavs[r]);
    }
    if (rail) rail.addEventListener('scroll', syncRail, { passive: true });

    /* ─── one product shelf per panel ──────────────────────────────────── */
    function syncCards(panel) {
      if (!panel) return;
      var cards = panel.querySelector('[data-cnt-cards]');
      var navs = [].slice.call(panel.querySelectorAll('[data-cnt-shelfnav]'));
      if (!cards) return;
      var max = cards.scrollWidth - cards.clientWidth - 1;
      var fits = max <= 0;
      for (var i = 0; i < navs.length; i++) {
        navs[i].hidden = fits;
        navs[i].disabled = navs[i].getAttribute('data-cnt-shelfnav') === 'prev'
          ? cards.scrollLeft <= 1
          : cards.scrollLeft >= max;
      }
    }

    for (var p = 0; p < panels.length; p++) {
      (function (panel) {
        var cards = panel.querySelector('[data-cnt-cards]');
        if (!cards) return;
        var navs = [].slice.call(panel.querySelectorAll('[data-cnt-shelfnav]'));
        for (var i = 0; i < navs.length; i++) {
          (function (btn) {
            btn.addEventListener('click', function () {
              var dir = btn.getAttribute('data-cnt-shelfnav') === 'prev' ? -1 : 1;
              scrollBy(cards, dir * cards.clientWidth * 0.9);
            });
          })(navs[i]);
        }
        cards.addEventListener('scroll', function () { syncCards(panel); }, { passive: true });
      })(panels[p]);
    }

    /* ─── tab swap ─────────────────────────────────────────────────────── */
    function select(index, focus) {
      for (var i = 0; i < tabs.length; i++) {
        var on = i === index;
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        /* Roving tabindex: exactly one tab is in the tab order. */
        tabs[i].tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].hidden = !on;
      }
      if (focus && tabs[index]) tabs[index].focus();
      /* A hidden panel measures 0, so its shelf can only be synced once shown. */
      syncCards(panels[index]);
      if (tabs[index] && rail) {
        var t = tabs[index];
        var left = t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2;
        if (reduced()) rail.scrollLeft = left;
        else if (rail.scrollTo) rail.scrollTo({ left: left, behavior: 'smooth' });
        else rail.scrollLeft = left;
      }
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (btn, i) {
        btn.addEventListener('click', function () { select(i, false); });
        btn.addEventListener('keydown', function (e) {
          var next = -1;
          if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = tabs.length - 1;
          if (next < 0) return;
          e.preventDefault();
          select(next, true);
        });
      })(tabs[t], t);
    }

    /* ─── quick-add ────────────────────────────────────────────────────── */
    sectionEl.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('[data-cnt-form]')) return;
      /* Stand down if something upstream already owns this submit (the bundle
         block's document-capture listener). */
      if (e.defaultPrevented) return;
      var button = form.querySelector('[data-cnt-add]');
      var card = form.closest('[data-cnt-card]');
      if (!button || !card) return;
      e.preventDefault();
      add(form, button, card);
    });

    function add(form, button, card) {
      /* The in-flight flag lives on the CARD. A per-button flag cannot see its
         sibling, so two controls would mean two concurrent adds. */
      if (card.moduloCntBusy) return;
      card.moduloCntBusy = true;
      button.classList.add('is-busy');

      var field = form.querySelector('[name="id"]');
      var id = field && field.value;
      if (!id) { done(); return; }

      window.fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          /* Opts out of the bundle block's in-flight fetch shim, which would
             otherwise answer with a synthetic 200 {"items":[]} and take the
             success path on an add that never happened. */
          'X-Modulo-Internal': 'concern-tabs'
        },
        /* No `sections` here on purpose: an invalid one returns 400 for the
           WHOLE request while the add still succeeds, so a caller treating
           non-2xx as failure would skip every refresh on an item now in the
           cart. ModuloCart.after() asks for sections on the /cart.js read. */
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(thenJson)
        .then(function () {
          if (window.ModuloCart) return window.ModuloCart.after({ open: false });
        })
        .catch(function () {
          /* The form still works without us — hand the shopper back to the
             native path rather than silently swallowing the failure. */
          form.submit();
        })
        .then(done, done);

      function done() {
        card.moduloCntBusy = false;
        button.classList.remove('is-busy');
      }
    }

    /* One observer per section; re-measures both rails on any reflow. */
    if (window.ResizeObserver) {
      new window.ResizeObserver(function () {
        syncRail();
        for (var i = 0; i < panels.length; i++) {
          if (!panels[i].hidden) syncCards(panels[i]);
        }
      }).observe(sectionEl);
    }

    /* Webfonts land after a deferred script and change every pill's width. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncRail();
        for (var i = 0; i < panels.length; i++) {
          if (!panels[i].hidden) syncCards(panels[i]);
        }
      });
    }

    syncRail();
    syncCards(panels[0]);
  }

  function bootstrap(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-cnt]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  /* An identical <script src> still executes once per tag, so the document
     listeners are wired exactly once. */
  if (!window.moduloCntWired) {
    window.moduloCntWired = true;
    document.addEventListener('shopify:section:load', function (e) { bootstrap(e.target); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootstrap(); });
  } else {
    bootstrap();
  }
})();
